import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { FadeUp, MaskedLines } from "@/components/Reveal";
import { lenisScroll } from "@/lib/scroll";
import { IMG } from "@/data/site";

export default function FinalCTA() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={ref} data-testid="final-cta-section" className="relative h-[95vh] min-h-[600px] overflow-hidden">
      <motion.img
        style={{ y, scale: 1.15 }}
        src={IMG.twilightPool}
        alt="Luxury home with pool at twilight — day to dusk editing by VCONTRACTZ"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-ink/55" />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-transparent to-ink" />

      <div className="relative z-10 h-full max-w-[1500px] mx-auto px-6 md:px-12 flex flex-col justify-center">
        <h2 className="font-display font-light text-[11vw] sm:text-6xl md:text-7xl lg:text-[6vw] leading-[0.98] tracking-tight">
          <MaskedLines
            lines={[
              "READY TO MAKE",
              "EVERY PROPERTY",
              <>
                LOOK ITS <em className="text-gold italic">BEST?</em>
              </>,
            ]}
          />
        </h2>
        <FadeUp delay={0.3} className="mt-8 max-w-xl">
          <p className="text-sm md:text-base text-ivory/80 font-light leading-relaxed">
            Let&rsquo;s create a post-production workflow that makes your photography
            stronger, your delivery easier and your brand more premium.
          </p>
        </FadeUp>
        <FadeUp delay={0.45} className="mt-10 flex flex-wrap gap-4">
          <button data-testid="final-cta-start-btn" data-cursor="START" onClick={() => lenisScroll("#contact")} className="btn-primary">
            Start a Project
            <ArrowUpRight size={14} />
          </button>
          <button data-testid="final-cta-pricing-btn" onClick={() => lenisScroll("#pricing")} className="btn-ghost">
            Request Custom Pricing
          </button>
        </FadeUp>
      </div>
    </section>
  );
}
